import React from 'react';
import { Button, Badge } from 'react-bootstrap';

export default function FilterButton({ name, isPressed, setFilter, count }) {
  return (
    <Button
      variant={isPressed ? "primary" : "outline-secondary"}
      className={`m-1 fw-semibold d-inline-flex align-items-center gap-2 px-3 shadow-sm filter-button ${
        isPressed ? "text-dark" : "text-light"
        }`}
      onClick={() => setFilter(name)}
    >
      {name}

      {/* 🎯 LE BADGE STYLISÉ EN FORME DE PILULE AUTOMATIQUE */}
      <Badge
        // rounded-pill : crée un cercle parfait / bg-dark ou bg-light pour le contraste
        className="px-2 py-1 fs-7 shadow-inner"
        bg={isPressed ? "light" : "secondary"}
        text={isPressed ? "dark" : "white"}
      >
        {count < 10 ? `0${count}` : count}
      </Badge>
    </Button>
  );
}